import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {projectEndingReasonToLabel} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'
import {useController, useFormContext} from 'react-hook-form'
import {z} from 'zod'

const ProjectFormEndingReasonSchema = ProjectFieldsSchema.pick({
    endingReason: true
})
type ProjectFormEndingReasonSchema = z.infer<typeof ProjectFormEndingReasonSchema>

export const ProjectFormEndingReasonField = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<ProjectFormEndingReasonSchema>()
    const {field} = useController({
        control,
        name: 'endingReason'
    })

    return (
        <InputSelect
            {...field}
            optionsMap={projectEndingReasonToLabel}
            label={t('projects:ending_reason_label')}
            onClear={() => field.onChange(null)}
        />
    )
}
